module.exports = __webpack_public_path__ + "static/img/8.0034892.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/8.png
// module id = GeBc
// module chunks = 0